<!DOCTYPE html>
<html>
<head>
  <title>{{ getMeetingTitle() }} - Phoenix</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <style>
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
    
    html, body {
      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      height: 100vh;
      width: 100vw;
      overflow: hidden;
      position: fixed;
      top: 0;
      left: 0;
    }
    
    .meet-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 9999;
      background: #000;
    }
    
    .meet-header {
      position: fixed;
      top: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(15px);
      padding: 15px 25px;
      border-radius: 25px;
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
      z-index: 1000;
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-width: 90%;
      min-width: 300px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      animation: floatIn 0.6s ease-out;
      transition: all 0.3s ease;
      opacity: 1;
      visibility: visible;
    }
    
    .meet-header.hidden {
      opacity: 0;
      visibility: hidden;
      transform: translateX(-50%) translateY(-20px);
    }
    
    @keyframes floatIn {
      from {
        opacity: 0;
        transform: translateX(-50%) translateY(-20px);
        box-shadow: 0 0 0 rgba(0, 0, 0, 0);
      }
      to {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
      }
    }
    
    .meet-title {
      color: #333;
      font-size: 18px;
      font-weight: 600;
      margin: 0;
    }
    
    .meet-time {
      color: #666;
      font-size: 14px;
      margin-top: 2px;
    }
    
    .back-button {
      background: #e41e3f;
      color: white;
      border: none;
      padding: 8px 16px;
      border-radius: 6px;
      cursor: pointer;
      font-size: 14px;
      font-weight: 500;
      transition: all 0.3s ease;
    }
    
    .back-button:hover {
      background: #c41e3a;
      transform: translateY(-1px);
    }
    
    .meet-header:hover {
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
      transform: translateX(-50%) translateY(-2px);
    }
    
    .jitsi-container {
      width: 100vw;
      height: 100vh;
      background: #000;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1;
    }
    
    .loading-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100vh;
      width: 100vw;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
    }
    
    .loading-spinner {
      width: 50px;
      height: 50px;
      border: 4px solid rgba(255, 255, 255, 0.3);
      border-top: 4px solid white;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      margin-bottom: 20px;
    }
    
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
    
    .loading-text {
      font-size: 18px;
      font-weight: 500;
      margin-bottom: 10px;
    }
    
    .loading-subtitle {
      font-size: 14px;
      opacity: 0.8;
    }
    
    .error-container {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100vh;
      width: 100vw;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      text-align: center;
      padding: 20px;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 1000;
    }
    
    .error-icon {
      font-size: 64px;
      margin-bottom: 20px;
    }
    
    .error-title {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 10px;
    }
    
    .error-message {
      font-size: 16px;
      opacity: 0.9;
      margin-bottom: 30px;
      max-width: 400px;
    }
    
    .retry-button {
      background: #e41e3f;
      color: white;
      border: none;
      padding: 12px 24px;
      border-radius: 8px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      transition: all 0.3s ease;
    }
    
    .retry-button:hover {
      background: #c41e3a;
      transform: translateY(-2px);
    }
    
    @media (max-width: 768px) {
      .meet-header {
        padding: 10px 15px;
        top: 15px;
        min-width: 280px;
        max-width: 95%;
        border-radius: 20px;
      }
      
      .meet-title {
        font-size: 16px;
      }
      
      .meet-time {
        font-size: 12px;
      }
      
      .back-button {
        padding: 6px 12px;
        font-size: 12px;
      }
    }
    
    /* Modo oscuro para la nube flotante */
    @media (prefers-color-scheme: dark) {
      .meet-header {
        background: rgba(30, 30, 30, 0.95);
        border: 1px solid rgba(255, 255, 255, 0.1);
      }
      
      .meet-title {
        color: white;
      }
      
      .meet-time {
        color: #ccc;
      }
    }
    
    /* Estilos personalizados para hacer el logo más grande */
    #jitsi-container iframe {
      /* Asegurar que el iframe ocupe todo el espacio */
      width: 100% !important;
      height: 100% !important;
    }
    
    /* Estilos para el logo de Jitsi Meet */
    #jitsi-container iframe body .leftwatermark,
    #jitsi-container iframe body .watermark,
    #jitsi-container iframe body .brand-watermark,
    #jitsi-container iframe body .main-logo,
    #jitsi-container iframe body .logo {
      transform: scale(2.5) !important;
      transform-origin: top left !important;
    }
    
    /* Estilos adicionales para el logo */
    #jitsi-container iframe body img[src*="logo-responsive.png"],
    #jitsi-container iframe body img[src*="phoenix"],
    #jitsi-container iframe body .watermark img,
    #jitsi-container iframe body .leftwatermark img {
      width: 200px !important;
      height: 60px !important;
      max-width: 200px !important;
      max-height: 60px !important;
    }
    
    /* Ocultar recomendaciones móviles de Jitsi Meet */
    #jitsi-container iframe body .app-promotion,
    #jitsi-container iframe body .mobile-app-promotion,
    #jitsi-container iframe body .native-app-promotion,
    #jitsi-container iframe body .browser-app-promotion,
    #jitsi-container iframe body .app-store-promotion,
    #jitsi-container iframe body .play-store-promotion,
    #jitsi-container iframe body .download-app-promotion,
    #jitsi-container iframe body .deep-linking-page,
    #jitsi-container iframe body .app-download-section,
    #jitsi-container iframe body .mobile-recommendations,
    #jitsi-container iframe body .app-recommendations,
    #jitsi-container iframe body .native-app-section,
    #jitsi-container iframe body .browser-app-section,
    #jitsi-container iframe body [class*="app-promotion"],
    #jitsi-container iframe body [class*="mobile-app"],
    #jitsi-container iframe body [class*="native-app"],
    #jitsi-container iframe body [class*="browser-app"],
    #jitsi-container iframe body [class*="download-app"],
    #jitsi-container iframe body [class*="app-store"],
    #jitsi-container iframe body [class*="play-store"] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      width: 0 !important;
      overflow: hidden !important;
    }
    
    /* Ocultar botón "Terminar reunión para todos" */
    #jitsi-container iframe body [data-testid="end-meeting-button"],
    #jitsi-container iframe body [aria-label*="Terminar reunión para todos"],
    #jitsi-container iframe body [aria-label*="End meeting for everyone"],
    #jitsi-container iframe body .end-meeting-button,
    #jitsi-container iframe body .end-meeting-for-all-button,
    #jitsi-container iframe body .moderator-end-meeting-button,
    #jitsi-container iframe body [class*="end-meeting"],
    #jitsi-container iframe body [class*="terminate-meeting"],
    #jitsi-container iframe body [class*="end-for-all"],
    #jitsi-container iframe body [class*="terminate-for-all"],
    #jitsi-container iframe body button:contains("Terminar reunión para todos"),
    #jitsi-container iframe body button:contains("End meeting for everyone") {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      width: 0 !important;
      overflow: hidden !important;
    }
  </style>
</head>
<body>
  <div class="meet-container">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
      <div class="loading-spinner"></div>
      <div class="loading-text">Cargando reunión...</div>
      <div class="loading-subtitle">Preparando tu videollamada</div>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-container">
      <div class="error-icon">⚠️</div>
      <div class="error-title">Error al cargar la reunión</div>
      <div class="error-message">{{ error }}</div>
      <button class="retry-button" (click)="goBack()">
        Volver al Dashboard
      </button>
    </div>

    <!-- Meeting Interface -->
    <div *ngIf="!loading && !error && appointmentData" class="meet-container">
      <!-- Header - Solo visible en el lobby -->
      <div *ngIf="showHeader" class="meet-header">
        <div>
          <h1 class="meet-title">{{ getMeetingTitle() }}</h1>
          <div class="meet-time">{{ getMeetingTime() }}</div>
        </div>
        <button class="back-button" (click)="goBack()">
          ← Volver
        </button>
      </div>

      <!-- Jitsi Meet Container -->
      <div id="jitsi-container" class="jitsi-container"></div>
    </div>
  </div>
</body>
</html>
